import CaseStudy from '../../CaseStudy/components/CaseStudy';
import clientData from '../data/clients';
import Clients from './Portfolio/Clients';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import Eyecandy from './Portfolio/Eyecandy';
import { Helmet } from 'react-helmet';
import React, {Fragment, useEffect, useState} from 'react';
import { Route, withRouter } from 'react-router-dom';
import styled from 'styled-components';
// import Tile from '../../Tile/components/Tile';
import PageTitle from '../../PageTitle/components/PageTitle';
import PageNavigation from '../../PageNavigation/components/PageNavigation';
import { client } from '../../Utils/Prismic';
import Prismic from 'prismic-javascript';
import { tileImage, tileSources } from '../../HtmlRenderer/components/Image';
import Loader from '../../Utils/Loader';
// import Card from "../../Card/components/CardLink";
import DataCard from "../../Card/components/DataCard";
// import Img from "../../Image/components/LazyImage";

const StyledContainer = styled(Container)`
  padding-top: 0;
  padding-bottom: 4rem;
`;
/* const StyledRow = styled(Row)`
  margin: 0 0 2.25rem;
`;
const InsightCategoryTag = styled.h4`
  font-size: 0.8rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 1rem 0 0;
`;
const InsightTitle = styled.div`
  display: block;
  font-size: 1.7rem;
  font-weight: 400;
  color: #000;
  line-height: 2.5rem;
`;
const InsightImage = styled.div`
  img {
    width: 100%;
    transition: all 0.25s ease-out;
    padding: 0;
    margin: 0;
  }
`;
const InsightLink = styled.div`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  line-height: 2rem;
  margin: 1rem 0;
  position: relative;
  text-transform: uppercase;
  z-index: 1;
`;
const Insight = styled.div`
  margin-bottom: 2rem;

  ${InsightLink} {
    position: relative;
    overflow: hidden;
    display: inline-block;

    ::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      padding-top: 0.1rem;
      background: #635bff;
      position: absolute;
      left: -2px;
      bottom: 0;
      transform: translate3d(-100%, 0, 0);
      transition: transform .2s ease-out;
    }
  }
  
  &:hover {
    ${InsightLink} {
      ::after {
        left: 0;
        transform: translate3d(0, 0, 0);
      }
    }
    
    // ${InsightImage} {
    //   img {
    //     padding: 1rem;
    //     margin-top: -1rem;
    //     margin-bottom: -1rem;
    //   }
    // }
  }
`; */
const StyledDataCard = styled(DataCard)`
  margin-bottom: 4rem;
`;

const Portfolio = (props) => {
  const [caseStudies, setCaseStudies] = useState(null);
  useEffect(() => {
      const fetchCaseStudies = async () => {
        const response = await client.query(
        Prismic.Predicates.at('document.type', 'case_study'),
       { orderings : '[my.case_study.position]', pageSize : 100 } // 100 is a max page size
      );
      if (response) {
        setCaseStudies(response.results);
      }
    };
    fetchCaseStudies();
  }, []);
  let CaseStudyItems = caseStudies ? null : <Loader/>;
  if (caseStudies && caseStudies.length > 0) {
    CaseStudyItems = caseStudies.map((caseStudy, i) => {
      const image = tileImage(caseStudy.data);
      const sources = tileSources(caseStudy.data);
      if (image && sources) {
        /* const data = {
          path: '/portfolio/' + caseStudy.uid,
          title: caseStudy.data.title,
          tags: caseStudy.data.tags,
          image: image,
          sources: sources
        }; */
        // return <Col col={12} md={6} key={i} noGutter={true}>
        return <Col col={12} md={6} key={i}>
          {/*<Tile component="Portfolio" aspectRatio="4:3" {...data} />*/}
          <StyledDataCard path={`/portfolio/${caseStudy.uid}/`}
                    defaultSource={image}
                    sources={sources}
                    title={caseStudy.data.title}
                    tag={caseStudy.data.tags}
                    linkTitle='View Case Study'
                    hideTag={true}
                    hideLink={true}
          />
          {/*<Card to={`/portfolio/${caseStudy.uid}/`}>*/}
          {/*  <Insight>*/}
          {/*    <InsightImage><img src={image} alt={caseStudy.data.title} /></InsightImage>*/}
          {/*    <InsightCategoryTag>{caseStudy.data.tags}</InsightCategoryTag>*/}
          {/*    <InsightTitle>{caseStudy.data.title}</InsightTitle>*/}
          {/*    <InsightLink>View Case Study</InsightLink>*/}
          {/*  </Insight>*/}
          {/*</Card>*/}
        </Col>;
      }

      return <React.Fragment key={i} />;
    });
  }

  return <Fragment>
    <Route path={`${props.match.url}/:caseStudy`}
           render={(props) => <CaseStudy/>
    }/>
    <Route exact path={'/portfolio'}
           render={() =>
      <Fragment>
        <Helmet>
          <meta name="description"
                content="View our portfolio and client case studies including companies like Verizon, Charming Charlie, H-E-B, and more."/>
          <title>User Experiences We Created for Our Clients | RMG</title>
          <link rel="canonical" href="https://www.rmgmedia.com/portfolio/"/>
        </Helmet>
        <PageTitle heading="Portfolio"
                   subHeading="Our clients and case studies."
        />
        <StyledContainer>
          <Row>
            {CaseStudyItems}
          </Row>
        </StyledContainer>
        <Clients data={clientData}/>
        <Eyecandy/>
        <PageNavigation prev="capabilities" next="insights" backgroundColor="#fff"/>
      </Fragment>
    }/>
  </Fragment>;
};

export default withRouter(Portfolio);
